<template>
<div class="chapter">
<div class="inner_page">
<h2 class="author">11</h2>
<p class="vers"><span>Laß dies</span> Stimmen und
Singen und<br class="calibre1"/>
Sagen des Rosenkranzes! Wen betest du<br class="calibre1"/>
an in diesem einsamen, dunklen Winkel<br class="calibre1"/>
des Tempels, in dem verschlossenen<br class="calibre1"/>
Tor?</p>
<p class="vers">Öffne die Augen und sieh, dein Gott<br class="calibre1"/>
ist nicht vor dir.</p>
<p class="vers">Er ist dort, wo der Pflüger den harten<br class="calibre1"/>
Grund pflügt, wo der Steinklopfer Steine<br class="calibre1"/>
bricht. Er ist mit ihnen in Sonne und<br class="calibre1"/>
Regen und wo sein Kleid bedeckt ist mit<br class="calibre1"/>
Staub. Leg ab deinen heiligen Mantel und<br class="calibre1"/>
komme herab mit ihm auf den staubigen<br class="calibre1"/>
Boden.</p>
<p class="vers">Befreiung? Wo ist die Befreiung zu<br class="calibre1"/>
finden? Unser Meister hat freudig die<br class="calibre1"/>
Bande der Schöpfung auf sich genommen;<br class="calibre1"/>
er ist mit uns für immer gebunden. <a id="page14" title="mabarosa/wedi"></a></p>
<p class="vers">Komm heraus aus deiner Betrachtung,<br class="calibre1"/>
laß Blumen und Weihrauch beiseite! Was<br class="calibre1"/>
schadet es, wenn deine Kleider zerreißen<br class="calibre1"/>
und fleckig werden. Geh ihm entgegen,<br class="calibre1"/>
stehe bei ihm in der Arbeit, dem Schweiß<br class="calibre1"/>
deiner Stirne. <a id="page15" title="mabarosa/wedi"></a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0012.vue?040162be